module.exports = __webpack_public_path__ + "img/return-box.6febb5d5.png";